import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AccountCreated.scss';

const AccountCreated = () => {
  const navigate = useNavigate();

  return (
    <div className="account-created">
      <div className="account-created__container">
        <div className="account-created__content">
          <div className="account-created__icon">🎉</div>
          <h1 className="account-created__title">Welcome to GuessNexus!</h1>
          <p className="account-created__description">
            Your account has been created successfully.
          </p>
          
          <div className="account-created__features">
            <div className="account-created__feature">
              <span className="account-created__feature-icon">🎯</span>
              <span className="account-created__feature-text">Daily challenges</span>
            </div>
            <div className="account-created__feature">
              <span className="account-created__feature-icon">🏆</span>
              <span className="account-created__feature-text">Achievements & streaks</span>
            </div>
            <div className="account-created__feature">
              <span className="account-created__feature-icon">📊</span>
              <span className="account-created__feature-text">Track your progress</span>
            </div>
          </div>

          <button 
            className="account-created__button"
            onClick={() => navigate('/', { replace: true })}
          >
            Continue to Games
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountCreated;